import { render, staticRenderFns } from "./ModelLayer.vue?vue&type=template&id=b8d78e94&scoped=true&"
import script from "./ModelLayer.vue?vue&type=script&lang=js&"
export * from "./ModelLayer.vue?vue&type=script&lang=js&"
import style0 from "./ModelLayer.vue?vue&type=style&index=0&id=b8d78e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d78e94",
  null
  
)

export default component.exports